// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format18 } from '../../constants';

/** Marshall Islands */
const MH: PhoneNumberData = [692, 'MH', 7, format18];

export default MH;
